module.exports = "<div data-component=\"app-pix-keys\">\n\t<app-main-title title=\"Minhas chaves\" subtitle=\"\"></app-main-title>\n\t<app-current-balance></app-current-balance>\n\t<app-pix-home-menu [selectedPixMenu]=\"pixMenu.CHAVES\"></app-pix-home-menu>\n\t<app-pix-keys-list></app-pix-keys-list>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/keys/list/list.component.html
// module id = ../../../../../src/app/master/pix/keys/list/list.component.html
// module chunks = main